module.exports = __webpack_public_path__ + "img/view-blue.svg";